module.exports = __webpack_public_path__ + "media/mypage/images/special/012-1fd3cd26d04448ad1e9c9281c6ada9f0.jpg";